import { createContext } from "react";
import { User } from "../../../../models";

//set initial value of user to null (pre-login)
export const UserContext = createContext<User | undefined>(undefined);
